/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroupTypeList } from '../../models/tag-group-type-list';

export interface GetTagGroupType$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
}

export function getTagGroupType(http: HttpClient, rootUrl: string, params?: GetTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroupTypeList>> {
  const rb = new RequestBuilder(rootUrl, getTagGroupType.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagGroupTypeList>;
    })
  );
}

getTagGroupType.PATH = '/tag-group-types';
